import 'vue-loading-overlay/dist/vue-loading.css';
import Vue from 'vue';
import LoadingPlugin from 'vue-loading-overlay';

Vue.use(LoadingPlugin, {
  color: '#00dbc6',
});
